import { Pipe, PipeTransform } from '@angular/core';
import { Documentos } from '../models/financas/documentos/documentos';
const COD_VALIDOS = {
  'R': true,
  'T': true,
  'A': true,
};
@Pipe({
  name: 'estadoDocValido',
  pure: true
}) export class EstadoDocValidoPipe implements PipeTransform {
  transform(documento: Documentos): boolean {
    if (documento && documento?.codEstadoDocumento) {
      return COD_VALIDOS[documento?.codEstadoDocumento.toUpperCase()];
    }
    return false;
  }
}
